<template>
  <span class="c-product-price">
    <span
      v-if="price"
      :class="textClass + ' c-product-price__price'"
    >
      <span
        v-if="price != 'Free'"
        :aria-label="price | currency"
        :class="[injectSezzle ? 'j-sezzle-price' : '']"
      >
        {{ price | currency }}
      </span>
      <span
        v-else
        :aria-label="price | currency"
        :class="[injectSezzle ? 'j-sezzle-price' : '']"
      >
        {{ price }}
      </span>
      <span
        v-if="compareAtPrice && validCompareAtPrice"
        :class="compareAtPriceClass + ' c-product-price__compare-at-price u-strikeout'"
        aria-hidden="true"
      >{{ compareAtPrice | currency }}</span>
      <slot />
    </span>
    <slot name="more" />
  </span>
</template>

<script>
export default {
  name: "ProductPrice",
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    price: {
      type: [String, Number],
      default: null,
      required: true
    },
    compareAtPrice: {
      type: [String, Number],
      default: null
    },
    injectSezzle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    validCompareAtPrice() {
      let price;
      let compareAtPrice;
      if (isNaN(this.price)) {
        price = Number(this.price.replace(/[^0-9.-]+/g,""))
      } else {
        price = this.price;
      }

      if (isNaN(this.compareAtPrice)) {
        compareAtPrice = Number(this.compareAtPrice.replace(/[^0-9.-]+/g,""))
      } else {
        compareAtPrice = this.compareAtPrice;
      }
      return !!(this.compareAtPrice && (price < compareAtPrice));
    },
    textClass() {
      switch (this.size) {
      case 'normal':
        return 't-heading-8'
      case 'small':
        return 't-heading-10'
      case 'large':
        return 't-heading-6'
      default: 
        return 't-heading-8'
      }
    },
    compareAtPriceClass() {
      let results = this.textClass + ' ' + this.textClass + '--light'
      if (this.injectSezzle) {
        results += 'j-sezzle-original-price'
      }
      return results;
    }
  }
}
</script>

<style lang="scss" scoped>
  .c-product-price {
    &__price {
      padding-bottom: rem(10px);
      &:not(:last-child) {
        margin-right: rem(5px);
      }
    }
    .j-sezzle-price {
      display: inline-block;
      padding-bottom: rem(10px);
    }
  }

</style>

